import { takeEvery } from 'redux-saga/effects';

import {
  SET_SCENE_TRANSITION_TYPE,
  SET_SCENE_TRANSITION_DURATION,
  SET_SCENE_TRANSITION_CONFIG
} from 'js/actionCreators/sceneTransitionsActions';

import { setSceneTransitionType } from './sceneSagas/setSceneTransitionType';
import { setSceneTransitionDuration } from './sceneSagas/setSceneTransitionDuration';
import { setSceneTransitionConfig } from './sceneSagas/setSceneTransitionConfig';

export default function* sceneTransitionsSaga() {
  yield takeEvery(SET_SCENE_TRANSITION_TYPE, setSceneTransitionType);
  yield takeEvery(SET_SCENE_TRANSITION_DURATION, setSceneTransitionDuration);
  yield takeEvery(SET_SCENE_TRANSITION_CONFIG, setSceneTransitionConfig);
}
